<template>
  <div class="container">
    <div class="panel panel-default">
      <div class="panel-body" id="imput-form">
        <h2>メール作成</h2>
        <form id="imput-form" name="form" method="post" @submit.prevent="setform">
          <p>
            <label for="form_1" class="control-label" >メールの件名</label>
            <br>
            <input
              type="text"
              v-model="mailTitle"
              class="form-control"
              id="mailTitle"
              name="mailTitle"
              required
            >
          </p>
          <p>
            <label for="form_1" class="control-label">案件名</label>
            <br>
            <input type="text" v-model="item" class="form-control" id="item" name="item">
          </p>
          <p>
            <label for="form_1" class="control-label">案件概要</label>
            <br>
            <textarea
              class="form-control"
              v-model="itemSummary"
              id="itemSummary"
              name="itemSummary"
              cols
              rows="5"
            ></textarea>
          </p>
          <p>
            <label for="form_1" class="control-label">期間</label>
            <br>
            <input type="text" v-model="period" class="form-control" id="period" name="period">
          </p>
          <p>
            <label for="form_1" class="control-label">場所</label>
            <br>
            <input type="text" v-model="place" class="form-control" id="place" name="place">
          </p>
          <p>
            <label for="form_1" class="control-label">単価</label>
            <br>
            <input type="text" v-model="price" class="form-control" id="price" name="price">
          </p>
          <p>
            <label for="form_1" class="control-label">スキル</label>
            <br>
            <textarea class="form-control" v-model="skill" id="skill" name="skill" cols rows="5"></textarea>
          </p>
          <p>
            <label for="form_1" class="control-label">備考</label>
            <br>
            <textarea class="form-control" v-model="note" id="note" name="note" cols rows="5"></textarea>
          </p>
          <input type="hidden" name="userId" v-model="userId">
          <div class="example-modal-window">
            <p align="right">
              <button class="btn btn-outline-secondary" type="submit">確認</button>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store.js'

export default {
created(){
  this.$cognito.getUserAttribute()
  },
 data () {
    return {
      campanyId: '',
      userId: '',
      password: '',
      mailTitle: '',
      item: '',
      itemSummary: '',
      period: '',
      place: '',
      price: '',
      skill: '',
      note: ''
    }
  },
  /*data:{
    validation: {
        mailTitle: false
      }
  },*/
  methods: {
    setform () { 
      store.commit('mutationType', {
        userId: this.userId,
        mailTitle: this.mailTitle,
        item: this.item,
        itemSummary: this.itemSummary,
        period: this.period,
        place:this.place,
        price: this.price,
        skill: this.skill,
        note: this.note,
      })
      this.$router.replace('/Confirmation')
    }
  }
}
</script>

<style scoped >
h2 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue